module.exports = __webpack_public_path__ + "img/GALLERY-BALENO-3.bdebed29.jpg";